import merge from 'deepmerge';

import common from './common';
import de from './de/pro.json';
import deAT from './de-AT/pro.json';
import deCH from './de-CH/pro.json';
import en from './en/pro.json';
import fr from './fr/pro.json';
import frCH from './fr-CH/pro.json';

// merge(one, two) --> merges two into one, overwriting any overlapping keys already in one
const pro = {
  fr: fr.pro,
  en: en.pro,
  de: de.pro,
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'fr-CH': merge(fr.pro, frCH.pro || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-CH': merge(de.pro, deCH.pro || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-AT': merge(de.pro, deAT.pro || {}),
};

export default merge(common, pro);
